export default __webpack_public_path__ + "static/media/blog2.aba7a3cb.jpg";